import black from "./black.png";
import white from "./white.png";
import { SuspenseImage } from "@/frontend/@ui/SuspenseImage";
import { useTheme } from "@/frontend/user/ThemeProvider";

export const BrandLogo = ({ className }: { className?: string }) => {
    const { theme } = useTheme();

    let logo: string;
    if (theme === "light") {
        logo = black;
    } else if (theme === "dark") {
        logo = white;
    } else {
        logo = window.matchMedia("(prefers-color-scheme: dark)").matches
            ? white
            : black;
    }

    const customClassName = " " + (className ?? "");

    return (
        <SuspenseImage
            src={logo}
            alt="Brand logo"
            className={`w-64 object-contain object-left ${customClassName}`}
        />
    );
};
